import { useAttrs, computed, getCurrentInstance } from 'vue-demi';

function useControlAttributes() {
  const attributes = useAttrs();
  return {
    readonly: computed(() => attributes['readonly']),
    disabled: computed(() => attributes['disabled']),
    'force-state': computed(() => attributes['force-state'])
  };
}

function useIdAttribute() {
  const attributes = useAttrs(),
    component = getCurrentInstance();
  return computed(() => {
    var _a;
    return (_a = attributes['id']) !== null && _a !== void 0 ? _a : component === null || component === void 0 ? void 0 : component.uid.toString();
  });
}

export { useIdAttribute as a, useControlAttributes as u };
